
export default class ImagePlaceholderElement extends HTMLElement {
    connectedCallback() {
        if (!this.hasChildNodes()) {
            this.innerHTML =
                '<svg viewBox="0 0 24 24" width="96" height="96" fill="none" stroke="#ccc" stroke-width="0.5">' +
                    '<rect x="3" y="3" width="18" height="18" rx="2"/>' +
                    '<path d="M3 16l5-5 4 4 3-3 6 6"/>' +
                    '<circle cx="15.5" cy="8.5" r="1.5"/>' +
                '</svg>' +
                '<span style="display:block;margin-top:8px;font-size:13px;color:#999;font-family:inherit;letter-spacing:0.5px;">Image Coming Soon</span>';
        }
    }
}

customElements.define('image-placeholder', ImagePlaceholderElement);
